export const convertToArabicNumerals = num => {
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return num
    .toString()
    .split('')
    .map(digit => arabicNumerals[parseInt(digit)])
    .join('');
};
